
        const styles = `:host {
  display: block; }

.sheet-container,
.sheet-header,
.sheet-close,
.sheet-handle,
.sheet-footer {
  background-color: white; }

.sheet-container {
  box-sizing: border-box;
  width: 100%;
  max-height: 90%;
  display: flex;
  flex-direction: column;
  position: fixed;
  z-index: 1000;
  bottom: 0;
  inset-inline-end: 0;
  overflow: hidden;
  border-radius: var(--nb-spacing-11) var(--nb-spacing-11) 0 0;
  font-family: inherit;
  -webkit-font-smoothing: antialiased;
  box-shadow: none;
  visibility: hidden;
  transform: translate(0, 105%);
  transition: none; }
  .sheet-container:focus {
    outline: none; }
  :host(.animating) .sheet-container,
  :host(.open) .sheet-container {
    visibility: visible;
    transition: var(--sheet-transition-duration) ease; }
  :host(.dragging) .sheet-container {
    transition: 0.01s ease; }

.sheet-header {
  position: sticky;
  top: 0;
  display: flex;
  flex-direction: column;
  padding: 0 1rem 1rem; }
  .sheet-header::after {
    position: absolute;
    content: '';
    bottom: 0;
    height: 1px;
    width: calc(100% - 2rem);
    background-color: var(--nb-color-gray-ccc); }

.sheet-handle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 30px;
  padding: 0;
  border-radius: var(--nb-spacing-11) var(--nb-spacing-11) 0 0;
  border: none; }
  .sheet-handle span {
    width: 81px;
    height: 5.9px;
    border-radius: 26px;
    background-color: rgba(0, 0, 0, 0.1);
    transition: 0.15s; }

.sheet-close {
  display: flex;
  margin-inline-start: auto;
  padding: 0;
  border: none;
  cursor: pointer;
  opacity: 0.7;
  transition: 0.15s; }
  .sheet-close:hover {
    opacity: 1; }

.sheet-header-text {
  display: flex;
  justify-content: space-between;
  align-items: start;
  gap: 0.5rem;
  color: #000;
  line-height: 1.2;
  font-size: 24px;
  font-weight: var(--nb-font-weight-07); }

.sheet-body {
  flex-grow: 1;
  padding: 1rem;
  font-weight: var(--nb-font-weight-03);
  overflow-y: scroll;
  overflow-x: hidden; }

.sheet-footer {
  padding: 1rem;
  border-radius: 24px 24px 0 0;
  box-shadow: rgba(0, 0, 0, 0.2) 0 2px 29px; }
  .sheet-footer:not(.in-use) {
    display: none; }

.sheet-backdrop {
  z-index: 999;
  position: fixed;
  pointer-events: none;
  opacity: 0;
  top: 0;
  inset-inline-start: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(0.8px);
  -webkit-backdrop-filter: blur(0.8px);
  background-color: rgba(0, 0, 0, 0.4);
  visibility: hidden;
  transition: var(--sheet-transition-duration) ease-out; }
  :host(.open) .sheet-backdrop {
    pointer-events: auto;
    visibility: visible;
    opacity: 1; }

@media screen and (min-width: 992px) {
  .sheet-header,
  .sheet-body,
  .sheet-footer {
    padding: 24px; }
  .sheet-footer {
    border-radius: 16px 16px 0 0; }
  .sheet-handle {
    display: none; }
  .sheet-header::after {
    width: calc(100% - 48px); }
  :host(.left) .sheet-container,
  :host(.right) .sheet-container {
    min-height: 100%;
    width: 100%;
    max-width: 33.333%;
    min-width: 450px;
    border-radius: 0;
    transform: translate(105%, 0); }
  :host(.left) .sheet-container {
    left: 0;
    right: auto;
    transform: translate(-105%, 0); }
  :host(.right) .sheet-container {
    right: 0;
    left: auto;
    transform: translate(105%, 0); }
  :host(.center) .sheet-container {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: auto;
    height: fit-content;
    max-width: 800px;
    border-radius: 0.5rem;
    opacity: 0; }
  :host(.center.open) .sheet-container {
    opacity: 1;
    transform: translate(-50%, -50%); } }

:host(.open) .sheet-container {
  box-shadow: rgba(0, 0, 0, 0.25) 0 14px 28px, rgba(0, 0, 0, 0.22) 0 10px 10px;
  transform: translate(0, 0); }
`;
        export default styles;
    